<script setup lang="ts">
import { useRouter } from 'vue-router'
import { BaseIconName, BaseButtonType } from '@cplug/design-system/components/props'
import { BaseEmptyView } from '@cplug/design-system/components'

const props = defineProps<{
  retryPath?: string
}>()

const emit = defineEmits<{
  retry: []
}>()

const { t } = useI18n()
const router = useRouter()

function onRetry (): void {
  if (props.retryPath) {
    router.replace(props.retryPath)
    return
  }

  emit('retry')
}
</script>

<template>
  <BaseEmptyView
    :title="t('MaintenanceTitle')"
    :description="t('MaintenanceDescription')"
    :icon-name="BaseIconName.Warning"
    icon-color="white"
    icon-background-color-class="bg-warning-foreground"
    :full-width="true"
    :secondary-button-text="t('TryAgain')"
    :secondary-button-type="BaseButtonType.Secondary"
    @click:secondary="onRetry"
  />
</template>

<i18n lang="yaml">
pt-br:
  MaintenanceTitle: 'Estamos em manutenção'
  MaintenanceDescription: 'No momento, estamos realizando ajustes e melhorias em nossos sistemas. Voltaremos em breve — obrigado pela sua compreensão!'
  TryAgain: 'Tentar novamente'
</i18n>
